import { useState } from 'react';
import { Menu } from 'lucide-react';
import { AdminSidebar } from './AdminSidebar';
import { useIsMobile } from '@sd/hooks/use-mobile';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent } from '@/components/ui/sheet';

interface AdminLayoutProps {
  children: React.ReactNode;
}

export function AdminLayout({ children }: AdminLayoutProps) {
  const isMobile = useIsMobile();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen w-full bg-background">
      {/* Desktop — sidebar hamesha dikhe (pehle jaisa) */}
      {!isMobile && <AdminSidebar />}

      {/* Mobile / tablet chhoti screen — drawer mein same sidebar */}
      {isMobile && (
        <Sheet open={sidebarOpen} onOpenChange={setSidebarOpen}>
          <SheetContent
            side="left"
            className="w-64 max-w-[85vw] p-0 [&>button]:hidden"
          >
            <AdminSidebar onNavigate={() => setSidebarOpen(false)} />
          </SheetContent>
        </Sheet>
      )}

      <main className="min-w-0 flex-1 overflow-auto">
        {isMobile && (
          <div className="sticky top-0 z-10 flex shrink-0 items-center gap-3 border-b bg-background px-4 py-3">
            <Button
              variant="ghost"
              size="icon"
              className="h-9 w-9"
              onClick={() => setSidebarOpen(true)}
              aria-label="Open menu"
            >
              <Menu className="h-5 w-5" />
            </Button>
            <span className="text-sm font-semibold text-foreground">Admin Panel</span>
          </div>
        )}
        {children}
      </main>
    </div>
  );
}
